<script setup lang="ts">
import { BookOpen, FolderOpen, MoreVertical, Pencil, Trash2, Ungroup } from '@lucide/vue'
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu, RowActionReveal } from 'catalyst-vue'
import { useControlSize } from '../../lib/library-layout'

/**
 * 集合格的動作選單。顯現行為與作品卡片的選單相同，交給套件的 row-action-reveal。
 * 「解散」與「刪除連同成員」是兩個動作：前者成員回書架，後者走批次刪除的確認。
 */
export type CollectionAction = 'read' | 'open' | 'edit' | 'dissolve' | 'delete'
/** merged：多一個「閱讀」在最前面，「開啟集合」改名為「管理成員」。 */
defineProps<{ title: string; merged?: boolean }>()
defineEmits<{ select: [key: CollectionAction] }>()
const controlSize = useControlSize()
</script>

<template>
  <RowActionReveal>
    <Dropdown>
      <DropdownButton plain :size="controlSize" class="comic-manage" :aria-label="`${title} 的集合選項`">
        <MoreVertical :size="17" aria-hidden="true" />
      </DropdownButton>
      <DropdownMenu anchor="bottom end">
        <DropdownItem v-if="merged" @click="$emit('select', 'read')">
          <BookOpen data-slot="icon" :size="16" aria-hidden="true" />
          <DropdownLabel>閱讀</DropdownLabel>
        </DropdownItem>
        <DropdownItem @click="$emit('select', 'open')">
          <FolderOpen data-slot="icon" :size="16" aria-hidden="true" />
          <DropdownLabel>{{ merged ? '管理成員' : '開啟集合' }}</DropdownLabel>
        </DropdownItem>
        <DropdownItem @click="$emit('select', 'edit')">
          <Pencil data-slot="icon" :size="16" aria-hidden="true" />
          <DropdownLabel>編輯集合</DropdownLabel>
        </DropdownItem>
        <DropdownItem @click="$emit('select', 'dissolve')">
          <Ungroup data-slot="icon" :size="16" aria-hidden="true" />
          <DropdownLabel>解散集合</DropdownLabel>
        </DropdownItem>
        <DropdownItem @click="$emit('select', 'delete')">
          <Trash2 data-slot="icon" :size="16" aria-hidden="true" />
          <DropdownLabel>刪除連同成員</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </RowActionReveal>
</template>
